import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AccessControlConfiguration } from './configuration';
import { AccessControlUserDto } from './dto';

@Injectable({
    providedIn: 'root',
})
export class AccessControlService {
    constructor(
        private readonly accessControlConfiguration: AccessControlConfiguration,
        private readonly http: HttpClient,
    ) {}

    getUsers(
        tenantId: string,
        serviceName: string,
        featureName: string,
        siteId: string,
    ): Observable<AccessControlUserDto[]> {
        const url: string = this.accessControlConfiguration.apiPaths.getUsers(
            tenantId,
            serviceName,
            featureName,
            siteId,
        );
        return this.http.get<AccessControlUserDto[]>(url);
    }
}
